import React, { memo } from 'react';
import PropTypes from 'prop-types';

/**
 * Atom: GroupSenderMC
 * Muestra el nombre del remitente de grupo en mensajes de grupo.
 *
 * Props:
 * - fullName: string (nombre completo del remitente)
 */

const GroupSenderMC = memo(({ message, className = '' }) => {
  if (!(message.isFromGroup && message.inboundSenderFullName)) return null;
  return (
    <div className={`tw-text-[#3CAAE1] tw-font-semibold ${className}`}>
      {message.inboundSenderFullName}
    </div>
  );
});

GroupSenderMC.displayName = 'GroupSenderMC';
GroupSenderMC.propTypes = {
  message: PropTypes.shape({
    isFromGroup: PropTypes.bool,
    inboundSenderFullName: PropTypes.string
  }).isRequired,
  className: PropTypes.string
};

export default GroupSenderMC;
